<div class="auth-page">
  <div class="auth-card">
    <div class="auth-card-inner">
      <div class="auth-visual">
        <p class="auth-visual-kicker">Appstrax</p>
        <h1 class="auth-visual-title">Log in</h1>
        <p class="auth-visual-subtitle">to your account</p>
        <div class="auth-visual-deco" aria-hidden="true"></div>
      </div>

      <div class="auth-form">
        <h2 class="auth-form-title">Welcome back!</h2>
        <p class="auth-form-lead">Log in to your account</p>

        <form (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label for="email" class="visually-hidden">Email address</label>
            <div class="input-with-icon">
              <i class="bi bi-envelope"></i>
              <input
                type="email"
                class="form-control"
                id="email"
                [(ngModel)]="email"
                name="email"
                placeholder="Email address"
                required
              />
            </div>
          </div>

          <div class="form-group">
            <label for="password" class="visually-hidden">Password</label>
            <div class="input-with-icon">
              <i class="bi bi-lock"></i>
              <input
                type="password"
                class="form-control"
                id="password"
                [(ngModel)]="password"
                name="password"
                placeholder="Password"
                required
              />
            </div>
          </div>

          @if (errorMessage) {
            <div class="alert alert-danger mb-3">
              {{ errorMessage }}
            </div>
          }

          <p class="auth-footer-link mb-3">
            Forgot your password?
            <a routerLink="/forgot-password">Reset password</a>
          </p>

          <button
            type="submit"
            class="btn btn-primary auth-submit"
            [disabled]="!isFormValid()"
          >
            @if (loading) {
              <span
                class="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
            }
            Log in
          </button>
        </form>

        <p class="auth-footer-link">
          Don't have an account? <a routerLink="/sign-up">Sign up</a>
        </p>
      </div>
    </div>
  </div>
</div>
